var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTechniques(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E117F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-tools",
    className: "st0",
    d: "M916.94,754.71L736.87,574.64c-34.68-34.53-87.5-43.13-131.34-21.37L441.61,389.35 v-95.43L244.77,146.29l-98.42,98.42l147.63,196.84h95.49l163.92,163.92c-21.68,43.85-13.09,96.62,21.37,131.34l180.01,180.07 c22.28,22.38,58.48,22.46,80.85,0.18c0.06-0.06,0.12-0.12,0.18-0.18l81.03-81.03c22.29-22.41,22.29-58.62,0-81.03L916.94,754.71z  M656.43,492.28c43.22-0.13,84.7,17.03,115.19,47.66l29.82,29.82c25.1-10.76,47.95-26.16,67.36-45.37 c55.03-54.94,77.16-134.75,58.28-210.18c-2.47-9.86-12.46-15.84-22.32-13.38c-3.27,0.82-6.25,2.52-8.62,4.92l-114.4,114.4 l-104.42-17.39l-17.43-104.4l114.4-114.4c7.21-7.29,7.15-19.04-0.14-26.25c-2.37-2.34-5.32-4-8.54-4.81 c-75.39-18.76-155.1,3.35-210.06,58.26c-42,42.22-64.9,99.79-63.36,159.32l126.24,126.24C630.89,493.81,643.64,492.31,656.43,492.28 z M496.65,618.38l-87.2-87.2L175.12,765.7c-38.43,38.43-38.43,100.74,0,139.17c38.43,38.43,100.74,38.43,139.17,0L504.37,714.8 c-12.13-30.65-14.81-64.23-7.69-96.42L496.65,618.38z M244.77,872.12c-20.38-0.01-36.89-16.54-36.88-36.92s16.54-36.89,36.92-36.88 c20.34,0.01,36.83,16.48,36.88,36.81C281.66,855.53,265.16,872.07,244.77,872.12z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechniques);
export default __webpack_public_path__ + "static/media/techniques.c4e0d8e894adf83c169b4152a6672c56.svg";
export { ForwardRef as ReactComponent };